import AttendApplicationListV3Page from './AttendApplicationListV3Page';

export default AttendApplicationListV3Page;
